import React, { FC, useState } from 'react';
import { Button, required, SaveButton, TextInput } from 'react-admin';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import Drawer from '~/components/Drawer';
import { SimpleForm } from '~/components/ra';
import Toolbar from '~/components/ra/Toolbar';
import { activateDevice } from '~/api/apiIdentity';
import useApiLazy from '~/hooks/useApiLazy';
import { useApiIdentityTranslate } from '..';

interface Props {
  apiIdentityId: string;
  deviceId: string;
  refetch: () => void;
}

const ActivateDeviceAction: FC<Props> = (props) => {
  const { apiIdentityId, deviceId, refetch } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const t = useApiIdentityTranslate();

  const [request, { loading }] = useApiLazy(activateDevice, [], {
    onSuccess: () => {
      refetch();
      handleClose();
    },
  });

  const handleSave = (formData: any) => {
    request({ apiIdentityId, deviceId, reason: formData.reason });
  };

  return (
    <>
      <Button label={t('activate')} onClick={handleOpen}>
        <CheckCircleOutlineIcon />
      </Button>
      <Drawer heading={t('activate')} open={open} onClose={handleClose}>
        <SimpleForm
          toolbar={
            <Toolbar>
              <SaveButton onSave={handleSave} />
            </Toolbar>
          }
          saving={loading}
        >
          <TextInput
            source='reason'
            label={t('reason')}
            multiline
            rows={5}
            rowsMax={20}
            validate={required()}
            fullWidth
          />
        </SimpleForm>
      </Drawer>
    </>
  );
};

export default ActivateDeviceAction;
